"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var config = _interopRequireWildcard(require("./config"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ConnectionAbstract = /*#__PURE__*/function () {
  function ConnectionAbstract() {
    (0, _classCallCheck2["default"])(this, ConnectionAbstract);
  }
  (0, _createClass2["default"])(ConnectionAbstract, [{
    key: "lookupAvailableComChainRepo",
    value: ///
    // [High level] Look for an available IPFS/IPNS node and return it
    ///
    function () {
      var _lookupAvailableComChainRepo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(storedEndPointsSuggestion) {
        var storedEndPoints, endPointLists, i, repo;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 1. Check if a list of endpoint is stored locally (avoid a IPNS slow call)
              storedEndPoints = storedEndPointsSuggestion || [];
              endPointLists = [storedEndPoints, config.confEndPointsOur, config.confEndPointsOther // 3. As a backup try standard ipfs servers (slow)
              ];
              i = 0;
            case 3:
              if (!(i < endPointLists.length)) {
                _context.next = 12;
                break;
              }
              _context.next = 6;
              return this.checkRepo(endPointLists[i]);
            case 6:
              repo = _context.sent;
              if (!repo) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return", repo);
            case 9:
              i++;
              _context.next = 3;
              break;
            case 12:
              return _context.abrupt("return", false);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function lookupAvailableComChainRepo(_x) {
        return _lookupAvailableComChainRepo.apply(this, arguments);
      }
      return lookupAvailableComChainRepo;
    }() ///
    // [High level] Get the list of endpoints and randomly select a up
    // and running one
    ///
  }, {
    key: "acquireEndPoint",
    value: function () {
      var _acquireEndPoint = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(repo) {
        var apiNodes, endpoint;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getCCEndPointList(repo);
            case 2:
              apiNodes = _context2.sent;
              if (apiNodes) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", false);
            case 5:
              _context2.next = 7;
              return this.selectEndPoint(apiNodes);
            case 7:
              endpoint = _context2.sent;
              return _context2.abrupt("return", {
                apiNodes: apiNodes,
                endpoint: endpoint
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function acquireEndPoint(_x2) {
        return _acquireEndPoint.apply(this, arguments);
      }
      return acquireEndPoint;
    }() ///
    // [Lower level] Get the list of ComChain end-points from given repo
    ///
  }, {
    key: "getCCEndPointList",
    value: function () {
      var _getCCEndPointList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(repo) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.http.get(repo + config.nodesRepo, {
                _: new Date().getTime()
              });
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              console.error("Failed to get endpoint list on ".concat(repo), _context3.t0);
              return _context3.abrupt("return", false);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 6]]);
      }));
      function getCCEndPointList(_x3) {
        return _getCCEndPointList.apply(this, arguments);
      }
      return getCCEndPointList;
    }() ///
    // [Lower level] Select a ComChain end-point with up and running APIs
    ///
  }, {
    key: "selectEndPoint",
    value: function () {
      var _selectEndPoint = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(nodes) {
        var id, node, success;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(nodes.length > 0)) {
                _context4.next = 11;
                break;
              }
              // randomly select a node (poor man's load balancing)
              id = Math.floor(Math.random() * nodes.length);
              node = nodes[id]; // check the node is up and running
              _context4.next = 5;
              return this.testNode(node);
            case 5:
              success = _context4.sent;
              if (!success) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", node);
            case 8:
              nodes.splice(id, 1);
              _context4.next = 0;
              break;
            case 11:
              return _context4.abrupt("return", false);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function selectEndPoint(_x4) {
        return _selectEndPoint.apply(this, arguments);
      }
      return selectEndPoint;
    }() ///
    // [Lower level] Test if a end-point has up and running APIs
    ///
  }, {
    key: "testNode",
    value: function () {
      var _testNode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(apiAddress) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.testDbApi(apiAddress);
            case 2:
              result = _context5.sent;
              if (result) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", false);
            case 5:
              return _context5.abrupt("return", this.testApi(apiAddress));
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function testNode(_x5) {
        return _testNode.apply(this, arguments);
      }
      return testNode;
    }() // //////////////////////////////////////////////////////////////////////////
  }, {
    key: "checkRepo",
    value: function () {
      var _checkRepo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(repoList) {
        var id, repo;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(repoList === null || repoList === void 0 ? void 0 : repoList.length)) {
                _context6.next = 17;
                break;
              }
              id = Math.floor(Math.random() * repoList.length);
              repo = repoList[id];
              _context6.prev = 3;
              _context6.next = 6;
              return this.http.get(repo + config.ping, null, {
                timeout: 3000
              });
            case 6:
              console.log("Connection OK to ".concat(repo));
              return _context6.abrupt("return", repo);
            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](3);
              console.log("Failed to make contact ".concat(repo, " in less that 3s"));
              console.log("  Reason: ".concat(_context6.t0));
              repoList.splice(id, 1);
            case 15:
              _context6.next = 0;
              break;
            case 17:
              return _context6.abrupt("return", false);
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 10]]);
      }));
      function checkRepo(_x6) {
        return _checkRepo.apply(this, arguments);
      }
      return checkRepo;
    }()
  }, {
    key: "testApi",
    value: function () {
      var _testApi = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(apiAddress) {
        var answer;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return this.http.get(apiAddress + '/api.php', null, {
                timeout: 5000
              });
            case 3:
              answer = _context7.sent;
              return _context7.abrupt("return", answer !== 'null' && !answer.error && answer);
            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);
              console.log("API Check: HTTP request to ".concat(apiAddress, " failed"), _context7.t0);
              return _context7.abrupt("return", false);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 7]]);
      }));
      function testApi(_x7) {
        return _testApi.apply(this, arguments);
      }
      return testApi;
    }()
  }, {
    key: "testDbApi",
    value: function () {
      var _testDbApi = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(apiAddress) {
        var answer;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.http.get(apiAddress + '/dbcheck.php', null, {
                timeout: 5000
              });
            case 3:
              answer = _context8.sent;
              return _context8.abrupt("return", answer === 'pong');
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);
              console.log("DbAPI Check: HTTP request to ".concat(apiAddress, " failed"), _context8.t0);
              return _context8.abrupt("return", false);
            case 11:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 7]]);
      }));
      function testDbApi(_x8) {
        return _testDbApi.apply(this, arguments);
      }
      return testDbApi;
    }()
    /**
     * Gets the configuration for the given currency
     *
     */
  }, {
    key: "getConfJSON",
    value: function () {
      var _getConfJSON = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(repo, currencyName) {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return this.http.get("".concat(repo).concat(config.configRepo, "/").concat(currencyName, ".json"), {
                _: new Date().getTime()
              });
            case 3:
              return _context9.abrupt("return", _context9.sent);
            case 6:
              _context9.prev = 6;
              _context9.t0 = _context9["catch"](0);
              return _context9.abrupt("return", false);
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 6]]);
      }));
      function getConfJSON(_x9, _x10) {
        return _getConfJSON.apply(this, arguments);
      }
      return getConfJSON;
    }()
  }]);
  return ConnectionAbstract;
}();
/**
 * Manages Persistent Store to keep list of nodes and avoid IPFS lookup
 * when possible.
 *
 */
var ConnectionMgrAbstract = /*#__PURE__*/function (_ConnectionAbstract) {
  (0, _inherits2["default"])(ConnectionMgrAbstract, _ConnectionAbstract);
  var _super = _createSuper(ConnectionMgrAbstract);
  function ConnectionMgrAbstract() {
    (0, _classCallCheck2["default"])(this, ConnectionMgrAbstract);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(ConnectionMgrAbstract, [{
    key: "lookupAvailableComChainRepo",
    value:
    /**
     * This lookup will store result in memory for speeding other methods.
     */
    function () {
      var _lookupAvailableComChainRepo2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(storedEndPointsSuggestion) {
        var apiNodeSuggestions, repo;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!storedEndPointsSuggestion) {
                apiNodeSuggestions = this.persistentStore.get('ApiNodes', '[]');
                storedEndPointsSuggestion = JSON.parse(apiNodeSuggestions);
              }
              _context10.next = 3;
              return (0, _get2["default"])((0, _getPrototypeOf2["default"])(ConnectionMgrAbstract.prototype), "lookupAvailableComChainRepo", this).call(this, storedEndPointsSuggestion);
            case 3:
              repo = _context10.sent;
              if (repo) {
                _context10.next = 6;
                break;
              }
              throw new Error('No repository available.');
            case 6:
              this.repo = repo;
              return _context10.abrupt("return", repo);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function lookupAvailableComChainRepo(_x11) {
        return _lookupAvailableComChainRepo2.apply(this, arguments);
      }
      return lookupAvailableComChainRepo;
    }()
    /**
     * This lookup will store result in memory for speeding other methods.
     * and saves the result in persistentStore for faster calls.
     */
  }, {
    key: "acquireEndPoint",
    value: function () {
      var _acquireEndPoint2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(repo) {
        var apiNodesEndpoint, apiNodes, endpoint;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (repo) {
                _context11.next = 5;
                break;
              }
              if (this.repo) {
                _context11.next = 4;
                break;
              }
              _context11.next = 4;
              return this.lookupAvailableComChainRepo();
            case 4:
              repo = this.repo;
            case 5:
              _context11.next = 7;
              return (0, _get2["default"])((0, _getPrototypeOf2["default"])(ConnectionMgrAbstract.prototype), "acquireEndPoint", this).call(this, repo);
            case 7:
              apiNodesEndpoint = _context11.sent;
              if (apiNodesEndpoint) {
                _context11.next = 10;
                break;
              }
              throw new Error('Endpoint list retrieval failed.');
            case 10:
              apiNodes = apiNodesEndpoint.apiNodes, endpoint = apiNodesEndpoint.endpoint;
              if (!(typeof endpoint !== 'string')) {
                _context11.next = 13;
                break;
              }
              throw new Error('No endpoint in list seems available.');
            case 13:
              this.persistentStore.set('ApiNodes', JSON.stringify(apiNodes));
              this.endpoint = endpoint;
              return _context11.abrupt("return", {
                apiNodes: apiNodes,
                endpoint: endpoint
              });
            case 16:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function acquireEndPoint(_x12) {
        return _acquireEndPoint2.apply(this, arguments);
      }
      return acquireEndPoint;
    }()
    /**
     * This lookup will store result in memory for speeding other methods.
     * and saves the result in persistentStore for faster calls.
     * - If argument `repo` is not provided, it'll use the last one in memory
     * leaved by a previous call of `lookupAvailableComChainRepo()`.
     * - If no previous call was made, it'll do one.
     */
  }, {
    key: "getConfJSON",
    value: function () {
      var _getConfJSON2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(currencyName, repo) {
        var conf;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (repo) {
                _context12.next = 5;
                break;
              }
              if (this.repo) {
                _context12.next = 4;
                break;
              }
              _context12.next = 4;
              return this.lookupAvailableComChainRepo();
            case 4:
              repo = this.repo;
            case 5:
              _context12.next = 7;
              return (0, _get2["default"])((0, _getPrototypeOf2["default"])(ConnectionMgrAbstract.prototype), "getConfJSON", this).call(this, repo, currencyName);
            case 7:
              conf = _context12.sent;
              if (conf) {
                _context12.next = 10;
                break;
              }
              throw new Error('Failed to get conf.');
            case 10:
              this.persistentStore.set('ServerConf', JSON.stringify(conf));
              this.conf = conf;
              // Completing with other informations
              conf.repo = repo;
              conf.custoRepo = repo + config.custoRepo;
              return _context12.abrupt("return", conf);
            case 15:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getConfJSON(_x13, _x14) {
        return _getConfJSON2.apply(this, arguments);
      }
      return getConfJSON;
    }()
    /**
     * Return conf stored in memory or persistent storage (need to
     * be not async).
     */
  }, {
    key: "getLocalConfJSON",
    value: function getLocalConfJSON() {
      if (this.conf) return this.conf;
      var cfgJson = this.persistentStore.get('ServerConf');
      var cfg = cfgJson ? JSON.parse(cfgJson) : {};
      // Completing with other informations if available
      if (this.repo) {
        cfg.repo = this.repo;
        cfg.custoRepo = this.repo + config.custoRepo;
      }
      return cfg;
    }
  }]);
  return ConnectionMgrAbstract;
}(ConnectionAbstract);
exports["default"] = ConnectionMgrAbstract;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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